import { useState } from "react"
import Button from "../../components/button"
import Modal from "../../components/modal"
import Headline6 from "../../components/headings/Headline6"
import { FormInput } from "../../wrappers/formInput"
import { useForm } from "react-hook-form"
import * as Yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"

export type ApproveOrRejectFormFields = {
  rejectComment: string
}

const validationSchema = Yup.object({
  rejectComment: Yup.string().required("Field is required"),
})

interface Props {
  reject: any
  submitCustomerStatus: any
  onClose: any
}

const ApproveOrReject: React.FC<Props> = ({
    reject,
    submitCustomerStatus,
    onClose
  }
) => {

  const formOptions = {
    resolver: yupResolver(validationSchema)
  }

  const {
    register,
    handleSubmit,
    formState,
  } = useForm<ApproveOrRejectFormFields>(formOptions)

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [comment , setComment] = useState<any>()

  const Submit = (data: any) => {

    if(reject){
      const value = {
        "rejectComment": data.rejectComment 
      }
      submitCustomerStatus(value)
      onClose()
    }else{      
      submitCustomerStatus()
      onClose()
    }
  }

  const rejectionComment = (e: any) => {    
    setComment(e.target.value) 
  }
 
  return (
    <Modal title="Availability" size="xsmall" onClose={onClose}>
      <form>
        <div className="form-group">
          <Headline6>Are you sure to Continue?</Headline6>
            {reject === true && 
                <FormInput<ApproveOrRejectFormFields>
                id="rejectComment"
                name="rejectComment"
                type="text"
                placeholder="Enter the reason for rejection*"
                onChange={(e: any) => {rejectionComment(e)}}
                register={register}
                errors={formState.errors}
              />
            }
        </div>
        <div className="popupAction">
          <Button variant='secondary'  onClick={onClose}>Cancel</Button>
            {reject === true && <Button variant='primary' onClick={handleSubmit(Submit)} >Continue</Button>}
            {reject === false && <Button variant='primary' onClick={(Submit)} >Continue</Button>}
        </div>
      </form>
    </Modal>
  )
}
export default ApproveOrReject